import type { ColorPickerConfig } from '#types/config/components/vf/colorPicker'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    rectangle: {
      cross: 'b b-grey-50 bg-white/60 bg-cross',
      swatch: 'after:(absolute inset-2 right-full -mb-1 content-empty duration-500 b-b-2 hover:(right-2))',
      swatchActive: 'after:(absolute inset-2 -mb-1 b-b-2 content-empty)',
      swatchInner: '',
      swatchLoading: '|h-10 c-grey-30',
    }
  },
  brandStyles: {
    rectangle: {
      container: {
        h: {
          sm: '2.5rem',
          md: '2.5rem',
          lg: '2.5rem'
        },
        w: {
          sm: '2.5rem',
          md: '2.5rem',
          lg: '2.5rem'
        }
      },
      cross: {
        inset: {
          sm: '0.5rem',
          md: '0.5rem',
          lg: '0.25rem'
        }
      },
      swatch: {
        inset: {
          sm: '0.5rem',
          md: '0.5rem',
          lg: '0.25rem'
        }
      },
      swatchUnavailable: {
        inset: {
          sm: '0.5rem',
          md: '0.5rem',
          lg: '0.25rem'
        }
      }
    }
  },
  config: {
    thumbnail: {
      rectangle: {
        height: 24,
        width: 24
      }
    }
  }
} satisfies RecursivePartial<ColorPickerConfig>
